// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tPUOP","required_label":"styles_required_label__kWzy1","message_box":"styles_message_box__AQw4c","right_comp":"styles_right_comp__NVcYT"};